import React from 'react';
import { SvgIcon } from '@material-ui/core';

const CalendarIcon = props => {
  return (
    <SvgIcon {...props}>
      <path d="M.64 10.3H23.4a.65.65 0 01.64.64V24.9a2.58 2.58 0 01-2.57 2.58H2.57A2.58 2.58 0 010 24.9V10.95a.65.65 0 01.64-.65zm23.4-2.36V6a2.58 2.58 0 00-2.57-2.58h-2.58V.64a.65.65 0 00-.65-.64H16.1a.65.65 0 00-.64.64v2.8H8.58V.63A.65.65 0 007.95 0H5.8a.65.65 0 00-.64.64v2.8H2.58A2.58 2.58 0 000 6v1.93a.65.65 0 00.64.64H23.4a.65.65 0 00.64-.64z" />
    </SvgIcon>
  );
};

export default CalendarIcon;
